// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/review_requests.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Reviewer } from "./reviewer_pb";
import { file_pull_requests_v1_reviewer } from "./reviewer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/review_requests.proto.
 */
export const file_pull_requests_v1_review_requests: GenFile = /*@__PURE__*/
  fileDesc("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", [file_pull_requests_v1_reviewer]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/review_requests
 *
 * Defined by PullRequests::PageData::SharedController#review_requests.
 *
 * @generated from message github.pull_requests.v1.ReviewRequestsResponse
 */
export type ReviewRequestsResponse = Message<"github.pull_requests.v1.ReviewRequestsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.PendingReviewRequest pending_review_requests = 1;
   */
  pendingReviewRequests: PendingReviewRequest[];

  /**
   * @generated from field: repeated github.pull_requests.v1.CompletedReview completed_reviews = 2;
   */
  completedReviews: CompletedReview[];

  /**
   * @generated from field: github.pull_requests.v1.Reviewer copilot_reviewer = 3;
   */
  copilotReviewer?: Reviewer;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewerRow copilot_reviewer_row = 4;
   */
  copilotReviewerRow?: CopilotReviewerRow;
};

/**
 * Describes the message github.pull_requests.v1.ReviewRequestsResponse.
 * Use `create(ReviewRequestsResponseSchema)` to create a new message.
 */
export const ReviewRequestsResponseSchema: GenMessage<ReviewRequestsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 0);

/**
 * @generated from message github.pull_requests.v1.CopilotReviewEffortOption
 */
export type CopilotReviewEffortOption = Message<"github.pull_requests.v1.CopilotReviewEffortOption"> & {
  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort value = 1;
   */
  value: CopilotReviewEffort;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffortAvailability availability = 4;
   */
  availability: CopilotReviewEffortAvailability;
};

/**
 * Describes the message github.pull_requests.v1.CopilotReviewEffortOption.
 * Use `create(CopilotReviewEffortOptionSchema)` to create a new message.
 */
export const CopilotReviewEffortOptionSchema: GenMessage<CopilotReviewEffortOption> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 1);

/**
 * @generated from message github.pull_requests.v1.CopilotReviewerRow
 */
export type CopilotReviewerRow = Message<"github.pull_requests.v1.CopilotReviewerRow"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: bool requestable = 2;
   */
  requestable: boolean;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort selected_review_effort = 3;
   */
  selectedReviewEffort: CopilotReviewEffort;

  /**
   * @generated from field: repeated github.pull_requests.v1.CopilotReviewEffortOption review_effort_options = 4;
   */
  reviewEffortOptions: CopilotReviewEffortOption[];

  /**
   * @generated from field: string learn_more_url = 5;
   */
  learnMoreUrl: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort last_executed_review_effort = 6;
   */
  lastExecutedReviewEffort: CopilotReviewEffort;
};

/**
 * Describes the message github.pull_requests.v1.CopilotReviewerRow.
 * Use `create(CopilotReviewerRowSchema)` to create a new message.
 */
export const CopilotReviewerRowSchema: GenMessage<CopilotReviewerRow> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 2);

/**
 * @generated from message github.pull_requests.v1.PendingReviewRequest
 */
export type PendingReviewRequest = Message<"github.pull_requests.v1.PendingReviewRequest"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: bool is_code_owner = 2;
   */
  isCodeOwner: boolean;

  /**
   * @generated from field: bool is_code_owner_from_delegation = 3;
   */
  isCodeOwnerFromDelegation: boolean;

  /**
   * Deferred reason; UNSPECIFIED (omitted) for an active request.
   *
   * @generated from field: github.pull_requests.v1.DeferredType deferred_type = 4;
   */
  deferredType: DeferredType;

  /**
   * Delegating team; absent when the request was not delegated (legacy null).
   *
   * @generated from field: github.pull_requests.v1.Reviewer delegated_from_team = 5;
   */
  delegatedFromTeam?: Reviewer;

  /**
   * ISO 8601 timestamp; absent for deferred requests (legacy null).
   *
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: github.pull_requests.v1.CopilotReviewEffort requested_copilot_review_effort = 7;
   */
  requestedCopilotReviewEffort: CopilotReviewEffort;
};

/**
 * Describes the message github.pull_requests.v1.PendingReviewRequest.
 * Use `create(PendingReviewRequestSchema)` to create a new message.
 */
export const PendingReviewRequestSchema: GenMessage<PendingReviewRequest> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 3);

/**
 * @generated from message github.pull_requests.v1.CompletedReview
 */
export type CompletedReview = Message<"github.pull_requests.v1.CompletedReview"> & {
  /**
   * Review id. int64 (serialized as a JSON string) since ids can exceed the
   * int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 2;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: github.pull_requests.v1.ReviewState state = 3;
   */
  state: ReviewState;

  /**
   * @generated from field: string head_sha = 4;
   */
  headSha: string;

  /**
   * ISO 8601 timestamp.
   *
   * @generated from field: string submitted_at = 5;
   */
  submittedAt: string;

  /**
   * @generated from field: bool has_write_access = 6;
   */
  hasWriteAccess: boolean;

  /**
   * @generated from field: bool can_re_request = 7;
   */
  canReRequest: boolean;

  /**
   * @generated from field: repeated github.pull_requests.v1.Reviewer on_behalf_of_teams = 8;
   */
  onBehalfOfTeams: Reviewer[];

  /**
   * State immediately before dismissal; UNSPECIFIED for reviews that have not
   * been dismissed or whose prior state is unavailable.
   *
   * @generated from field: github.pull_requests.v1.ReviewState dismissed_review_state = 9;
   */
  dismissedReviewState: ReviewState;
};

/**
 * Describes the message github.pull_requests.v1.CompletedReview.
 * Use `create(CompletedReviewSchema)` to create a new message.
 */
export const CompletedReviewSchema: GenMessage<CompletedReview> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 4);

/**
 * Why a pending review request is deferred. UNSPECIFIED is an active
 * (non-deferred) request, which the legacy JSON encodes as null.
 *
 * @generated from enum github.pull_requests.v1.DeferredType
 */
export enum DeferredType {
  /**
   * @generated from enum value: DEFERRED_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEFERRED_TYPE_CODEOWNER = 1;
   */
  CODEOWNER = 1,

  /**
   * @generated from enum value: DEFERRED_TYPE_COPILOT = 2;
   */
  COPILOT = 2,
}

/**
 * Describes the enum github.pull_requests.v1.DeferredType.
 */
export const DeferredTypeSchema: GenEnum<DeferredType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 0);

/**
 * State of a completed review. The legacy JSON encodes this as a lowercase
 * string ("approved", "commented", "changes_requested", "dismissed",
 * "pending").
 *
 * @generated from enum github.pull_requests.v1.ReviewState
 */
export enum ReviewState {
  /**
   * @generated from enum value: REVIEW_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REVIEW_STATE_COMMENTED = 2;
   */
  COMMENTED = 2,

  /**
   * @generated from enum value: REVIEW_STATE_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: REVIEW_STATE_CHANGES_REQUESTED = 4;
   */
  CHANGES_REQUESTED = 4,

  /**
   * @generated from enum value: REVIEW_STATE_DISMISSED = 5;
   */
  DISMISSED = 5,
}

/**
 * Describes the enum github.pull_requests.v1.ReviewState.
 */
export const ReviewStateSchema: GenEnum<ReviewState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 1);

/**
 * @generated from enum github.pull_requests.v1.CopilotReviewEffort
 */
export enum CopilotReviewEffort {
  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_LOW = 1;
   */
  LOW = 1,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_HIGH = 3;
   */
  HIGH = 3,
}

/**
 * Describes the enum github.pull_requests.v1.CopilotReviewEffort.
 */
export const CopilotReviewEffortSchema: GenEnum<CopilotReviewEffort> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 2);

/**
 * @generated from enum github.pull_requests.v1.CopilotReviewEffortAvailability
 */
export enum CopilotReviewEffortAvailability {
  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: COPILOT_REVIEW_EFFORT_AVAILABILITY_COMING_SOON = 2;
   */
  COMING_SOON = 2,
}

/**
 * Describes the enum github.pull_requests.v1.CopilotReviewEffortAvailability.
 */
export const CopilotReviewEffortAvailabilitySchema: GenEnum<CopilotReviewEffortAvailability> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 3);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ReviewRequestsResponseSchema, "082bfcaa933f")
registerSchemaHash(CopilotReviewEffortOptionSchema, "b15c67fe0dd8")
registerSchemaHash(CopilotReviewerRowSchema, "ff9bb13787d4")
registerSchemaHash(PendingReviewRequestSchema, "a0205440412a")
registerSchemaHash(CompletedReviewSchema, "d639fe1cc877")
